<div class="slideout-content" *blockUI="'section-block'">
    <!-- Modal to add new project starts-->
    <div class="modalsd modal-slide-in sdfade new-project-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-project modal-content pt-0" [formGroup]="requestForm" (ngSubmit)="onSubmit()">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="toggleSidebar('create-request')">
                    ×
                </button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title" id="exampleModalLabel">Talep Ekle</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <div class="row">
                        <!-- Title -->
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label for="title">Talep Adı</label>
                                <input type="text" formControlName="title" class="form-control"
                                    placeholder="Talep başlığı Giriniz." />
                                <div
                                    *ngIf="requestForm.get('title').invalid && (requestForm.get('title').dirty || requestForm.get('title').touched)">
                                    <small class="text-danger" *ngIf="requestForm.get('title').errors.required">Başlık
                                        zorunludur.</small>
                                    <small class="text-danger" *ngIf="requestForm.get('title').errors.maxlength">Başlık
                                        en fazla 100 karakter olabilir.</small>
                                </div>
                            </div>
                        </div>
                        <!-- Description -->
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label for="description">Açıklama</label>
                                <textarea formControlName="description" class="form-control"
                                    placeholder="Talep Açıklaması Giriniz."></textarea>
                            </div>
                        </div>
                        <!-- Start Date -->
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label>Oluşturma Tarihi</label>
                                <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" [setDate]="date"
                                    formControlName="startDate"></ng2-flatpickr>
                            </div>
                        </div>

                        <!-- Company -->
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label>Firma</label>
                                <ng-select [items]="companies" bindLabel="companyName" bindValue="id"
                                    formControlName="companyId" (change)="onCompanyChange($event)">
                                </ng-select>
                            </div>
                        </div>

                        <!-- Company Personnel -->
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label>Firma Personelleri</label>
                                <ng-select bindValue="id" bindLabel="name" formControlName="companyPersonId"
                                    (change)="onPersonChange($event)">
                                    <ng-option *ngFor="let user of selectedPersons" [value]="user.id">{{user.name + ' '
                                        + user.lastname}}</ng-option>
                                </ng-select>
                            </div>
                        </div>
                        <!-- Responsible Person -->
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label>Yetkili Kişi Seç</label>
                                <ng-select bindLabel="name" bindValue="id" formControlName="personId"
                                    (change)="onCompanyPersonChange($event)">
                                    <ng-option *ngFor="let user of companyPersons" [value]="user.id">{{user.name + ' '
                                        + user.lastname}}</ng-option>
                                </ng-select>
                            </div>
                        </div>

                        <!-- Urgency Level -->
                        <div class="col-10 mb-1 ml-1">
                            <div class="form-group">
                                <label>Aciliyet Durumu</label>
                                <ng-select [items]="urgencyLevels" bindLabel="label" bindValue="value"
                                    formControlName="urgency"></ng-select>
                            </div>
                        </div>

                        <div class="col-10 mb-1 ml-1" *ngIf="requestTaskId">
                            <div class="form-group">
                                <label>Durumu</label>
                                <ng-select [items]="statusList" bindLabel="label" bindValue="value"
                                    style="border: 1px solid orange;" formControlName="status"></ng-select>
                            </div>
                        </div>
                    </div>
                    <!-- Submit and Cancel Buttons -->
                    <button type="submit" [disabled]="requestForm.invalid || !selectedCompany"
                        *ngIf="authService.isEndpointStatus('POST.Writing.CreateRequestTask')"
                        class="btn btn-primary col-10 mb-1 ml-1">{{requestTaskId ? 'Güncelle' : 'Ekle'}}</button>
                    <button type="reset" class="btn btn-outline-secondary col-10 mb-1 ml-1"
                        (click)="toggleSidebar('create-request')">İptal</button>
                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new project Ends-->
</div>